import React from 'react';

const Legal = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Mentions Légales</h1>
      <div className="prose max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Informations légales</h2>
          <p className="text-gray-700 mb-4">
            ASDA Genève<br />
            Association Suisse des Diplômés en Assurance – Section Genève<br />
            C/o La Mobilière Genève<br />
            Route du Grand-Lancy 6A<br />
            1227 Les Acacias<br />
            Email: geneve@asda.ch<br />
            Site web: www.asda-ge.ch
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Responsabilité</h2>
          <p className="text-gray-700 mb-4">
            Les informations fournies sur ce site sont à titre informatif uniquement. L'ASDA Genève s'efforce de maintenir les informations à jour et exactes, mais ne peut garantir leur exhaustivité ou leur actualité.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Propriété intellectuelle</h2>
          <p className="text-gray-700">
            Tout le contenu de ce site (textes, images, logos) est la propriété de l'ASDA Genève et est protégé par les lois sur la propriété intellectuelle.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Legal;